import { ModalV2 } from '@equip.health/ui';
import EditDocument from './EditDocument';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import { DocumentCenterEvents } from '~/analytics/documentCenterEvents';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';

interface EditDocumentModalProps {
  id: string;
  isOpen: boolean;
  onClose: () => void;
  documentDetails: Partial<PatientDocumentV2>;
}

const EditDocumentModal = ({
  id,
  isOpen,
  onClose,
  documentDetails,
}: EditDocumentModalProps) => {
  const { trackEvent } = useAnalytics();

  const handleClose = () => {
    trackEvent(DocumentCenterEvents.editModalCloseIconClicked, {
      Source: AnalyticsSourceValues.DOCUMENT_CENTER,
    });
    onClose();
  };
  return (
    <ModalV2
      id={id}
      isOpen={isOpen}
      onClose={handleClose}
      size="4xl"
      title="Edit Document properties"
    >
      <EditDocument
        documentDetails={documentDetails}
        modalId={id}
        onClose={onClose}
      />
    </ModalV2>
  );
};

export default EditDocumentModal;
